import ReactDOM from 'react-dom/client'
import './index.css'
import Routes from './Routes.tsx';

ReactDOM.createRoot(document.getElementById('root')!).render(
    <Routes/>   
)
